import { consent, createGtag, event, set as setGtag } from 'vue-gtag';
import { createScript } from '@shared/composables/createScript.js';
import { navigateWithAttribution } from '@shared/composables/attributionNavigation.js';

let analyticsEnabled = false;
const trackedOnce = new Set();

function hasMeta(name) {
    return document.querySelector(`meta[name=${name}]`) !== null;
}

function metaContent(name) {
    return document.querySelector(`meta[name=${name}]`)?.content.trim() ?? '';
}

export function initialiseAnalytics() {
    const tagId = metaContent('ga4_measurement_id');

    if (tagId === '') {
        return null;
    }

    const defaultConsent = {
        analytics_storage: 'denied',
        ad_storage: 'denied',
        ad_user_data: 'denied',
        ad_personalization: 'denied',
    };
    const storedConsent = {};

    if (hasMeta('performance_cookies_allowed')) {
        storedConsent.analytics_storage = 'granted';
    }

    if (hasMeta('advertising_cookies_allowed')) {
        storedConsent.ad_storage = 'granted';
        storedConsent.ad_user_data = 'granted';
        storedConsent.ad_personalization = 'granted';
    }

    const gatewayPath = metaContent('google_tag_gateway_path');
    const plugin = createGtag({
        tagId,
        config: {
            send_page_view: true,
        },
        hooks: {
            'config:init:before': () => {
                consent('default', defaultConsent);
                setGtag('url_passthrough', true);

                if (Object.keys(storedConsent).length > 0) {
                    consent('update', storedConsent);
                }
            },
        },
        resource: gatewayPath === ''
            ? { preconnect: true }
            : { inject: false },
    });

    if (gatewayPath !== '') {
        const scriptPath = gatewayPath.endsWith('/') ? gatewayPath : `${gatewayPath}/`;

        void createScript(scriptPath, false).catch((error) => {
            console.error('Failed to load the Google tag gateway script.', error);
        });
    }

    analyticsEnabled = true;
    window.ensoTyresAnalytics = {
        event: trackAnalyticsEvent,
        eventOnce: trackAnalyticsEventOnce,
        navigate: navigateWithAttribution,
    };

    return plugin;
}

export function updateAnalyticsConsent(params) {
    if (analyticsEnabled) {
        consent('update', params);
    }
}

export function trackAnalyticsEvent(name, params = {}) {
    if (analyticsEnabled) {
        event(name, params);
    }
}

export function trackAnalyticsEventOnce(name, params = {}) {
    if (!analyticsEnabled || trackedOnce.has(name)) {
        return;
    }

    trackedOnce.add(name);
    event(name, params);
}
